/*
* 文書の内容確認
*/

export default class DocumentLinks {
  constructor() {
    this.$documentLinks = document.querySelectorAll('[data-target="documentLink"]');
    this.$browseables = document.querySelectorAll('[data-button="browseable"]');
    this.$confirmLink = document.querySelectorAll('[data-button="confirmLink"]');
  }

  attachEvent() {
    const checklistArr = [].slice.call(this.$documentLinks);
    const $entryButton = document.querySelector('[data-entry="entryButton"]');

    Array.prototype.forEach.call( this.$browseables, $item => {
      const url = $item.getAttribute('data-url');
      const endpoint = $item.getAttribute('data-endpoint');
      const token = document.querySelector('meta[name="csrf-token"]').content;
      const params = JSON.stringify({
        browse: {
          browseable_type: $item.getAttribute('data-browseable-type'),
          browseable_id: $item.getAttribute('data-browseable-id')
        },
      });

      $item.addEventListener('click', () => {
        const xhr = new XMLHttpRequest();
        const win = window.open('', '_blank');
        xhr.open('POST', endpoint, true);
        xhr.setRequestHeader('X-CSRF-Token', token);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = function() {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              win.location.href = url;
              $item.classList.remove('is-show');
              $item.classList.add('is-checked');
              $item.nextElementSibling.classList.add('is-show');
              entryButtonActivation();
            } else {
              alert('通信に失敗しました。');
              win.close();
            }
          }
        };
        xhr.onerror = function() {
          alert('通信に失敗しました。');
          win.close();
        };
        xhr.send(params);
      });
    });

    Array.prototype.forEach.call( this.$confirmLink, $item => {
      $item.addEventListener('click', () => {
        $item.classList.add('is-checked');
        entryButtonActivation();
      });
    });

    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        // bfcacheから復元された場合、ページをリロードして最新の状態を取得
        location.reload();
        return;
      }
      entryButtonActivation();
    });

    function entryButtonActivation() {
      const check = checklistArr.every(value => value.classList.contains('is-checked'));
      const $numberBoxes = document.querySelectorAll('[data-target="numberBox"]');
      const $error = document.querySelector('[data-target="error"]');

      if(check == true && $entryButton != null) {
        $entryButton.classList.add('is-active');
        
        // 数字入力フィールドが存在しない場合のみdisabled制御を実行
        if ($numberBoxes.length === 0) {
          if ($error) {
            $error.classList.contains('is-hide') ? $entryButton.disabled = false : $entryButton.disabled = true;
          } else {
            $entryButton.disabled = false;
          }
        } else {
          // 数値入力フィールドが存在する場合、inputイベントをトリガー
          // これによりnumberモジュールのvalidationが実行される
          $numberBoxes[0].dispatchEvent(new Event('input'));
        }
      }
      
    }
  }
}
